import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { color, themeGet, textContrast } from '@magalu/stereo-ui-styles';
import { background, compose, flex, grid, layout, space } from 'styled-system'; // Components

import Text from '../Text';
import Heading from '../Heading';
import Flex from '../Flex'; // Extend style from responsive image component

import Image from '../ResponsiveImage';
export const truncateText = lines => css`
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
`;
export const Container = styled.a.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => prop.includes('ads-') || prop.includes('redirect') ? true : defaultValidatorFn(prop)
}).attrs(props => {
  return Object.assign({}, props);
})({
  transition: 'box-shadow ease 0.4s',
  textDecoration: 'none',
  cursor: 'pointer',
  display: 'grid',
  overflow: 'hidden',
  gridTemplateAreas: '"image" "body"',
  justifyContent: 'space-between',
  borderRadius: themeGet('radii.default')
}, _ref => {
  let {
    enableHover
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["enableHover"]);

  return enableHover && {
    ':hover': {
      boxShadow: themeGet('boxShadows.4')(props)
    }
  };
}, compose(background, color, space, grid, layout, flex), textContrast);
export const CardImage = styled(Image).attrs(props => Object.assign({
  imageWidth: '100%',
  imageHeight: '100%',
  objectFit: 'cover'
}, props))`
  grid-area: image;
`;
export const CardBody = styled(Flex).attrs(props => Object.assign({
  color: 'inherit',
  background: 'inherit',
  padding: '16px 14px',
  flexDirection: 'column'
}, props))`
  grid-area: body;
`;
export const CardTitle = styled(Heading).attrs(props => Object.assign({
  fontSize: 6,
  color: 'inherit',
  lineHeight: '1.2em'
}, props))`
  ${({
  truncate,
  lines = 2
}) => truncate && truncateText(lines)}
`;
export const CardSubtitle = styled(Text).attrs(props => Object.assign({
  forwardedAs: 'small',
  color: 'inherit',
  display: 'block',
  fontSize: 0,
  marginTop: 2
}, props))`
  ${({
  truncate,
  lines = 2
}) => truncate && truncateText(lines)}
`;
export const CardText = styled(Text).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'light',
  lineHeight: '1.5em',
  color: 'inherit',
  marginTop: '3'
}, props))`
  ${({
  truncate,
  lines = 4
}) => truncate && truncateText(lines)}
`;